import { ComponentSingleStyleConfig, StyleFunctionProps } from '@chakra-ui/react'

export const textStyles: ComponentSingleStyleConfig = {
  baseStyle: (props: StyleFunctionProps) => ({
    color: props.colorMode === 'dark' ? 'whiteAlpha.600' : "blackAlpha.700"
  }),
}